'use client';

import LoginView from './LoginView';
import ResetView from './ResetView';
import { useAuth } from '@app/_context/authContext';

export default function LoginCard() {
    const { auth } = useAuth();
    if (auth?.reset) return <ResetView />;
    return <LoginView />;
}
